import { createFileRoute } from '@tanstack/react-router';

import { profilesSearchSchema } from '@/features/llm-profiles';
import { HarnessesAdminPage } from '@/features/organization-admin';

export const Route = createFileRoute('/admin/harnesses')({
  // The LLM profiles grid's order and filter live in the address (spec 136 FR-011), so
  // an order or a filter is shareable and bookmarkable. Namespaced keys because this
  // one route carries three sections.
  //
  // The schema is a plain `z.object`, so **anything else in the query string is
  // dropped**, and that is the intent rather than an oversight (R-F55): this route had
  // no `validateSearch` at all, so it tolerated every key, and `.passthrough()` would
  // preserve that — including the stale keys a bookmark from before this spec carries.
  // The only params this surface has ever meant are the two below. `onViewChange`'s
  // `{ ...prev, ...next }` spread is about the two keys *this* schema declares — it
  // keeps a filter when only the order changes — not about preserving unknown ones.
  validateSearch: profilesSearchSchema,
  component: HarnessesAdminRoute,
});

export function HarnessesAdminRoute() {
  const { profilesSort, profilesQ } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <HarnessesAdminPage
      view={{ profilesSort, profilesQ }}
      onViewChange={(next) => {
        // `replace: true`: re-sorting or retyping a filter is not a place in history
        // worth stepping back through one keystroke at a time.
        void navigate({
          search: (prev) => ({ ...prev, ...next }),
          replace: true,
        });
      }}
    />
  );
}
